/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { calendar_events_CreateEventRequest } from '../models/calendar_events_CreateEventRequest';
import type { calendar_events_UpdateEventRequest } from '../models/calendar_events_UpdateEventRequest';
import type { models_CalendarEvent } from '../models/models_CalendarEvent';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EventsService {
    /**
     * List calendar events within a date range
     * Get all calendar events within the specified date range
     * @param startDate Start date (RFC3339 format)
     * @param endDate End date (RFC3339 format)
     * @param groupId Filter by group ID
     * @param employeeId Filter by employee ID
     * @param eventType Filter by event type
     * @returns models_CalendarEvent OK
     * @throws ApiError
     */
    public static getApiV1Events(
        startDate: string,
        endDate: string,
        groupId?: string,
        employeeId?: string,
        eventType?: string,
    ): CancelablePromise<Array<models_CalendarEvent>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/events',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'groupId': groupId,
                'employeeId': employeeId,
                'eventType': eventType,
            },
            errors: {
                400: `Invalid parameters`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create a new calendar event
     * Create a new calendar event. eventType PROSPECT_TOUR is refused with 422 CALENDAR_EVENT_PROSPECT_TOUR_IMMUTABLE: those events belong to the prospect tour endpoints, and one minted here could never be updated or deleted through this route.
     * @param request Event creation request
     * @returns models_CalendarEvent Created
     * @throws ApiError
     */
    public static postApiV1Events(
        request: calendar_events_CreateEventRequest,
    ): CancelablePromise<models_CalendarEvent> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/events',
            body: request,
            errors: {
                400: `Invalid request`,
                422: `The event type is a prospect tour and is managed by the prospect tour endpoints`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a calendar event
     * Delete a calendar event by ID. An event of type PROSPECT_TOUR is refused with 422 CALENDAR_EVENT_PROSPECT_TOUR_IMMUTABLE: deleting it here would strand the prospect tour that points at it.
     * @param id Event ID
     * @param deleteSeries Delete entire series for recurring events
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Events(
        id: string,
        deleteSeries?: boolean,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/events/{id}',
            path: {
                'id': id,
            },
            query: {
                'deleteSeries': deleteSeries,
            },
            errors: {
                404: `Event not found`,
                422: `The event is a prospect tour and is managed by the prospect tour endpoints`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get a calendar event by ID
     * Get a single calendar event by its ID
     * @param id Event ID
     * @returns models_CalendarEvent OK
     * @throws ApiError
     */
    public static getApiV1Events1(
        id: string,
    ): CancelablePromise<models_CalendarEvent> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/events/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Event not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update a calendar event
     * Update an existing calendar event. An event of type PROSPECT_TOUR is refused with 422 CALENDAR_EVENT_PROSPECT_TOUR_IMMUTABLE: the prospect tour endpoints own it and keep it in step with its prospect_tours row.
     * @param id Event ID
     * @param request Event update request
     * @returns models_CalendarEvent OK
     * @throws ApiError
     */
    public static putApiV1Events(
        id: string,
        request: calendar_events_UpdateEventRequest,
    ): CancelablePromise<models_CalendarEvent> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/events/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                404: `Event not found`,
                422: `The event is a prospect tour and is managed by the prospect tour endpoints`,
                500: `Internal server error`,
            },
        });
    }
}
